// Quotation Profile Types
export const profiles = {
  INDIVIDUAL: 'individual',
  RETENCION: 'retencion',
  COLLECTIVE: 'colectiva',
  PROFESIONAL_COLLEGES: 'colegios',
};

export const individuals = [
  profiles.INDIVIDUAL,
  profiles.RETENCION,
  profiles.PROFESIONAL_COLLEGES,
];
export default profiles;
